import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ValueProposition from './components/ValueProposition';
import FeaturedCollections from './components/FeaturedCollections';
import HotDeals from './components/HotDeals';
import AboutUs from './components/AboutUs';
import Lookbook from './components/Lookbook';
import Footer from '@/components/feature/Footer';

export default function HomePage() {
  return (
    <main className="min-h-screen font-sans">
      <Navigation />
      <HeroSection />
      <ValueProposition />
      <FeaturedCollections />
      <HotDeals />
      <AboutUs />
      <Lookbook />
      <Footer />
    </main>
  );
}
